import { OverlayModule } from "@angular/cdk/overlay";
import { PortalModule } from "@angular/cdk/portal";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { DialogContainerComponent } from "./dialog-container.component";
import { DialogService } from "./dialog.service";

@NgModule({
	imports: [CommonModule, OverlayModule, PortalModule, DialogContainerComponent],
	providers: [DialogService],
})
export class DialogModule {}
